/* eslint-disable import/prefer-default-export */
import { object, string } from "yup";

export const validationSchema = object().shape({
  email: string()
    .email("Invalid email address")
    .required("Email address is required")
});
